import axios from "axios";
import { notification } from "antd";
const commonAxios = axios.create();
commonAxios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

commonAxios.defaults.headers["x-access-token"] =
    localStorage.getItem(`x-access-token`) || ``;
commonAxios.defaults.headers["x-dashboard-staffid"] =
    localStorage.getItem(`x-dashboard-staffid`) || ``;

commonAxios.interceptors.request.use(
    function (config) {
        if (
            config.url === "/users/login" ||
            config.url == "/users/forgetPassword" ||
            config.url.includes("/verify-password")
        ) {
            delete commonAxios.defaults.headers["x-access-token"];
            delete commonAxios.defaults.headers["x-dashboard-staffid"];
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    },
);

commonAxios.interceptors.response.use(
    function (config) {
        if (
            config.config.url === "/users/login" &&
            config.status === 200 &&
            config.data.success
        ) {
            const { data } = config.data;
            commonAxios.defaults.headers["x-access-token"] = data.token;
            commonAxios.defaults.headers["x-dashboard-staffid"] = data.user?.id;
            localStorage.setItem(`x-access-token`, data.token);
            localStorage.setItem(`userRoleId`, data.user?.role_id);
            localStorage.setItem(`userEmail`, data.user?.email);
            localStorage.setItem(`x-dashboard-staffid`, data.user?.id);
            localStorage.setItem(`userFirstname`, data.user?.first_name);
            localStorage.setItem(`loggedIn`, true);
            localStorage.setItem(
                "hotel_assigned",
                data.user?.hotel_ids?.length ? true : false,
            );
            localStorage.setItem("page_reloaded", true);
            if (data.user.role_id == "exv" && !data.user.hotel_ids.length) {
                notification.warning({
                    message: <strong>No data available</strong>,
                    description:
                        "You currently do not have access to any hotel data. Please reach out to your administrator",
                });
            }
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
        // return error;
    },
);

export default function HTTP(url, data = {}, method = "POST", { signal } = {}) {
    return new Promise((resolve, reject) => {
        commonAxios({
            method,
            url,
            data,
            signal,
        })
            .then(function (response) {
                if (
                    !response.data?.success &&
                    response.data?.err_code === "ERR_TOKEN_AUTH_USER"
                ) {
                    localStorage.clear();
                    window.location.reload();
                }
                if (response.data?.err_code) {
                    return reject(response.data?.message);
                }
                // handle success
                return resolve(response.data);
            })
            .catch(function (error) {
                // Axios cancellation errors may not have a request config.
                if (axios.isCancel(error)) return reject(error);
                // handle error
                if (
                    (error.config.url =
                        "/users/login" && error.response?.data?.success === 0)
                ) {
                    return resolve(error.response.data);
                }
                return reject(error);
            });
    });
}
